import {
	border,
	height,
	margin,
	maxHeight,
	maxWidth,
	minHeight,
} from "@mui/system";

const styles = (theme) => ({
	cardSubText: {
		fontWeight: 500,
		fontSize: "20px",

		"@media (max-width: 600px)": {
			fontSize: "16px",
		},
	},
	containerComponent: {
		display: "flex",
		flexDirection: "column",

		width: "100%",
	},
	paper: {
		padding: "16px",
		display: "flex",
		flexDirection: "row",
		gap: 1,
		justifyContent: "space-between",
		minHeight: "200px",
		width: "100%",
		maxWidth: "100%",
		borderRadius: "16px",
		position: "relative",
		overflow: "hidden",
	},
	linearProgress: {
		position: "absolute",
		top: 0,
		left: 0,
		width: "100%",
		zIndex: 1,
	},
	containerGraphRam: {
		borderRadius: "10px",
		overflow: "hidden",
		height: "100%",
		display: "flex",
		flexDirection: "column",
		justifyContent: "space-between",
		border: `1px solid `,
		borderColor:
			theme.palette.mode === "dark"
				? theme.palette.colors.black.medium
				: theme.palette.colors.black.dark,
	},
	containerCardData: {
		width: "30%",
		maxWidth: "100px",
		display: "flex",
		flexDirection: "column",
		margin: "15px 0 0 0",
		justifyContent: "center",
	},
	containerCardDataTitle: {
		width: "100%",
		borderRadius: "10px 10px 0 0",
		display: "flex",
		flexDirection: "column",
		justifyContent: "left",
		alignItems: "center",
		gap: 1,
		margin: "0 0 5px 0",
	},

	cardTitle: {
		fontSize: "20px",
		fontWeight: "bold",
	},

	containerGrid: {
		marginTop: "15px",
		display: "flex",
		flexDirection: "row",
		width: "100%",
		height: "100%",
		maxHeight: "280px",
	},
	containerGraph: {
		width: "280px",
		height: "100%",
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
	},
	containerResponsiveContainer: {
		width: 190,
	},
	containerTextRam: {
		width: "100%",
		marginTop: "-55px",
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
	},
});

export default styles;
